import Vue from 'vue'

import Vuetify from 'vuetify'

// import vue-panzoom
import panZoom from 'vue-panzoom'
import { createPinia, PiniaVuePlugin } from 'pinia'

import Event from './components/Event.vue'

import Layout from './layout/Layout.vue'

import BaseWrapper from './layout/BaseWrapper.vue'

import 'vuetify/dist/vuetify.min.css'

import titleMixin from './mixins/titleMixin'
import JustRouter from './layout/JustRouter'

/**
 * Uncomment below when compiling to production
 */
// window.Vue.config.devtools = false
// window.Vue.config.debug = false
// window.Vue.config.silent = true
// window.Vue.config.productionTip = false

Vue.use(panZoom)

require('./bootstrap')

const { router } = require('./router.js')

Vue.component('EventComponent', Event)
Vue.component('LayoutComponent', Layout)
Vue.component('BaseWrapper', BaseWrapper)
Vue.component('JustRouter', JustRouter)
Vue.use(Vuetify)
Vue.mixin(titleMixin)

Vue.use(PiniaVuePlugin)
const pinia = createPinia()

const app = new Vue({
  el: '#app',
  vuetify: new Vuetify(),
  router,
  pinia,
})
